import { ArrowRight } from "lucide-react";

import type { ComplianceRow } from "@/content/commercial/compliance";
import { COMPLIANCE_ROWS } from "@/content/commercial/compliance";
import { CommercialSecondaryCta } from "@/components/commercial/commercial-cta";

export type { ComplianceRow };
export { COMPLIANCE_ROWS, SOLAR_COMPLIANCE_ROWS } from "@/content/commercial/compliance";

export function CommercialAccreditationsTable({
 rows = COMPLIANCE_ROWS,
 showCta = true,
 showViewAllLink = false,
 viewAllHref = "/commercial-compliance",
 viewAllLabel = "View full compliance & accreditations",
}: {
 rows?: ComplianceRow[];
 showCta?: boolean;
 showViewAllLink?: boolean;
 viewAllHref?: string;
 viewAllLabel?: string;
}) {
 return (
 <section className="border-b border-border/40 bg-secondary/25 py-12 md:py-16">
 <div className="container-page max-w-5xl">
 <div className="max-w-3xl mb-8">
 <p className="text-xs font-bold uppercase tracking-widest text-accent mb-2">Compliance</p>
 <h2 className="text-2xl md:text-4xl font-bold text-foreground leading-tight">
 Accreditations &amp; Insurances
 </h2>
 <p className="text-sm md:text-base text-muted-foreground mt-3">
 Renewal dates and certificates are available on request while our diligence pack is finalised.
 </p>
 </div>

        <div className="overflow-x-auto rounded-2xl border border-border bg-card shadow-sm">
 <table className="w-full text-left text-sm">
 <thead className="bg-secondary/40 text-foreground">
 <tr>
 <th scope="col" className="px-4 py-3 font-bold">
 Accreditation / Insurance
 </th>
 <th scope="col" className="px-4 py-3 font-bold">
 Status
 </th>
 <th scope="col" className="px-4 py-3 font-bold">
 Cover
 </th>
 <th scope="col" className="px-4 py-3 font-bold">
 Renewal
 </th>
 </tr>
 </thead>
 <tbody>
 {rows.map((row) => (
 <tr key={row.name} className="border-t border-border">
 <td className="px-4 py-3 font-medium text-foreground">{row.name}</td>
 <td className="px-4 py-3 text-muted-foreground">{row.status}</td>
 <td className="px-4 py-3 text-muted-foreground">{row.cover || "-"}</td>
 <td className="px-4 py-3 text-muted-foreground">{row.renewal || "Available on request"}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>

 {(showCta || showViewAllLink) && (
 <div className="mt-6 flex flex-col sm:flex-row gap-3 items-start sm:items-center">
 {showCta && (
 <CommercialSecondaryCta label="Download Capability Statement / Accreditation Pack" />
 )}
 {showViewAllLink && (
 <a
 href={viewAllHref}
 className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent hover:text-accent/80 transition-colors"
 >
 {viewAllLabel}
 <ArrowRight className="h-4 w-4" aria-hidden />
 </a>
 )}
 </div>
 )}
 </div>
 </section>
 );
}
